module.exports = __webpack_public_path__ + "img/new-year-xiaomi.06a2ccce.svg";